var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMobileMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "20px",
    viewBox: "0 0 25 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Mobile-Menu") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile-Header",
    transform: "translate(-277.000000, -20.000000)",
    fill: "#4B4E6A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Mobile-Menu",
    transform: "translate(277.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.66666667,3.33333333 L23.3333333,3.33333333 C24.255,3.33333333 25,2.58666667 25,1.66666667 C25,0.746666667 24.255,0 23.3333333,0 L1.66666667,0 C0.746666667,0 0,0.746666667 0,1.66666667 C0,2.58666667 0.746666667,3.33333333 1.66666667,3.33333333 M23.3333333,16.6666667 L1.66666667,16.6666667 C0.746666667,16.6666667 0,17.4116667 0,18.3333333 C0,19.255 0.746666667,20 1.66666667,20 L23.3333333,20 C24.255,20 25,19.255 25,18.3333333 C25,17.4116667 24.255,16.6666667 23.3333333,16.6666667 M25,10 C25,10.92 24.255,11.6666667 23.3333333,11.6666667 L1.66666667,11.6666667 C0.746666667,11.6666667 0,10.92 0,10 C0,9.08 0.746666667,8.33333333 1.66666667,8.33333333 L23.3333333,8.33333333 C24.255,8.33333333 25,9.08 25,10"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMobileMenu);
export default __webpack_public_path__ + "static/media/Icon-Mobile-Menu.07a344c56178676289243150c1e708f5.svg";
export { ForwardRef as ReactComponent };